/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LicensePlanType = {
    None: 'None',
    PayWhatYouUse: 'PayWhatYouUse',
    Budget: 'Budget',
    Fixed: 'Fixed'
} as const;
export type LicensePlanType = typeof LicensePlanType[keyof typeof LicensePlanType];


export function LicensePlanTypeFromJSON(json: any): LicensePlanType {
    return LicensePlanTypeFromJSONTyped(json, false);
}

export function LicensePlanTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicensePlanType {
    return json as LicensePlanType;
}

export function LicensePlanTypeToJSON(value?: LicensePlanType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the LicensePlanType interface.
 */
 export function instanceOfLicensePlanType(value: any): value is LicensePlanType {
    return Object.values(LicensePlanType).includes(value)
}

